// Operations — v1.1 §7. Built in Step 7.
//
// C1 — THE DEFAULT VIEW IS "NOW"
// ===============================
// `operations.html` opened on Overview. §7.1 is LOCKED and states the default
// view is **Now**, and §3.8 gives `/operations` → `OperationsPage` the new home
// "Operations → Now". C1 said: "One line. Fix it in Step 7 and do not carry the
// mockup's default forward."
//
// The behaviour is fixed here: the index tab renders `Now`, so landing on
// /v2/operations with no sub-route selects Now, not Overview. The label is
// fixed too — `XNAV.operations[0]` in `shell/areas.js` now reads "Now", so the
// tab and the surface it opens on agree.
//
// §7.3 EXPLICITLY REJECTS A PM/KANBAN PRODUCT
// ===========================================
// `/pipeline` as a board is intentionally homeless (§3.12). Its DATA relocates to
// Workflows; the board does not come with it. `/pipeline` and `/velocity` are not
// deleted (R3), and their endpoints are untouched — this branch changes no file
// under `backend/`, so /api/velocity/metrics and /api/velocity/trends cannot have
// been broken from this lane.
//
// TINY TIM DECOUPLING, DONE ADDITIVELY
// ====================================
// §3.8: `OperationsPage` must be stripped of Tiny Tim coupling, because Tiny Tim
// is a REPLACE verdict heading to the EA. `OperationsPage` imports
// `TinyTimCostTile` and `TinyTimToolHistory` at lines 3–4 and renders both at
// 280–281. None of that appears in this surface — which is the decoupling, done
// the additive way R2 requires: the old page keeps both, keeps working, and stays
// mounted until the EA does everything it did. The coupling still exists in
// `OperationsPage`; this lane only reads that file and does not edit it. Recorded
// rather than left silent.
//
// Cost tile and tool history go to Settings → Infrastructure per A1, not here.
// §7 is about what the company is doing now, which cost accounting is not.
import React from "react";

import { useShell } from "../ShellContext";
import Automation from "./operations/Automation";
import History from "./operations/History";
import Now from "./operations/Now";
import Recommendations from "./operations/Recommendations";
import Workflows from "./operations/Workflows";

import "./operations/operations.css";

// Keyed by the `tab` segment in `XNAV.operations`. The empty key is the area's
// home, and it is Now — see C1 above.
const PAGES = {
  "": Now,
  workflows: Workflows,
  automation: Automation,
  recommendations: Recommendations,
  history: History,
};

export default function OperationsArea() {
  const { tab } = useShell();
  // An unknown segment falls back to the area home rather than rendering nothing.
  // The designed not-found state is §3.11's REDESIGN row and belongs to whoever
  // builds it; until then the home is the honest destination.
  const Page = PAGES[tab] || PAGES[""];
  return <Page />;
}
